<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.05 2c0 .033-.002.066-.005.099a5.002 5.002 0 0 1 3.942 5.695c-.063 2.76-.075 4.323.94 6.83A1 1 0 0 1 15 16H5a1 1 0 0 1-.921-1.389c.966-2.29.964-3.764.96-6.06-.001-.48-.002-.997.006-1.565 0-.034.003-.067.006-.1a5.002 5.002 0 0 1 4.004-4.787A1 1 0 1 1 11.05 2Zm-1 17a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2Z" />
    </svg>
</template>
